<script setup lang="ts">
import { computed, ref } from "vue";

import { $can } from "@/services/UtilitiesService";
import { usePointStore } from "@/stores/point-store";

import CheckVerified from "./_CheckVerified.vue";

import type { CheckPointData } from "@/models/Point";

withDefaults(defineProps<{
  isScore?: boolean;
  checkpointReference: string;
  checkpoint: Omit<CheckPointData, "reference">;
}>(), {  })

const checkFileReference = computed(() => (__props.checkpoint.check.scope === "record" ? __props.checkpoint.appliesTo : undefined));

const dataValueFromUserVerified = ref(__props.checkpoint.dataValueFromUser != null);

const canEditDataValue = computed(() => $can("amendCheckpointDataValues"));
const canEditEvaluation = computed(() => $can("amendCheckpointEvaluations"));

const resolvedDataValue = computed(() => __props.checkpoint.dataValueFromUser ?? __props.checkpoint.dataValue ?? "");

function updateDataValue(dataValue: string | null) {
  if (!canEditEvaluation.value || __props.checkpoint == null) return;

  try {
    // Optimistically update
    dataValueFromUserVerified.value = dataValue != null;

    usePointStore().updateCheckPoint(__props.checkpointReference, checkFileReference.value, { settingValue: true, dataValue });
  } catch (error) {
    // In the case of an error, revert to the original state
    dataValueFromUserVerified.value = __props.checkpoint.dataValueFromUser != null;
  }
}
</script>
<template>
  <td aria-hidden="true" :class="{ '!tw-border-t-0': isScore }" />
  <td>
    <div class="tw-flex tw-grow tw-select-none tw-items-center tw-gap-1">
      <span class="tw-text-xs">Value:</span>
      <!-- TODO: Use the editable input instead, always in the editing state except when the change is being saved -->
      <input
        type="text"
        :value="resolvedDataValue"
        :disabled="!canEditDataValue"
        class="tw-flex-1 tw-rounded tw-border tw-border-black/30 tw-bg-white tw-p-1"
      />
    </div>
  </td>
  <td v-if="$slots.scc125" />
  <td>
    <div class="tw-grid tw-place-items-center">
      <CheckVerified
        :disabled="!canEditDataValue"
        :checked="dataValueFromUserVerified"
        @update:checked="(checked) => updateDataValue(checked ? (checkpoint.dataValue ?? '') : null)"
      />
    </div>
  </td>
</template>
